import { marked } from "marked";

export function useMdHelpers() {
  const parseMD = (md) => {
    if (!md) return "";

    // Configure marked renderer to add CSS classes
    const renderer = new marked.Renderer();

    renderer.paragraph = (text) => `<p class="md-paragraph">${text}</p>`;
    renderer.heading = (text, level) =>
      `<h${level} class="md-heading md-h${level}">${text}</h${level}>`;
    renderer.list = (body, ordered) => {
      const tag = ordered ? "ol" : "ul";
      return `<${tag} class="md-list">${body}</${tag}>`;
    };
    renderer.listitem = (text) => `<li class="md-list-item">${text}</li>`;
    renderer.table = (header, body) =>
      `<table class="md-table"><thead>${header}</thead><tbody>${body}</tbody></table>`;
    renderer.tablerow = (content) => `<tr class="md-table-row">${content}</tr>`;
    renderer.tablecell = (content, flags) => {
      const tag = flags.header ? "th" : "td";
      return `<${tag} class="md-table-cell">${content}</${tag}>`;
    };
    renderer.strong = (text) => `<strong class="md-strong">${text}</strong>`;
    renderer.em = (text) => `<em class="md-em">${text}</em>`;
    renderer.code = (code) => `<code class="md-code">${code}</code>`;
    renderer.codespan = (code) => `<code class="md-inline-code">${code}</code>`;

    return marked.parse(md, {
      breaks: true,
      renderer: renderer,
    });
  };

  return {
    parseMD,
  };
}
